import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {PageService} from '../../services/page.service';
import {DomSanitizer} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-p-details',
  templateUrl: './p-details.component.html',
  styleUrls: ['./p-details.component.css']
})
export class PDetailsComponent implements OnInit {
  id: string;
  title: any;
  content: any;
  constructor(private route: ActivatedRoute , private pageService: PageService , private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(paramMap => {
      this.id = paramMap.get('id');
      this.getPageDetailsById(this.id);

    });
  }

  getPageDetailsById(id) {
    this.pageService.getPageDetailsById(id).subscribe(response => {


      switch (this.pageService.checkPageLang()) {
        case 'ar':
          var parser = new DOMParser();
          var doc = parser.parseFromString(response.title_ar, 'text/html');
          this.title = this.sanitizer.bypassSecurityTrustHtml(response.title_ar);
          this.content = this.sanitizer.bypassSecurityTrustHtml(response.content_ar);

          break;
        default:
          var parser = new DOMParser();
          var doc = parser.parseFromString(response.title, 'text/html');
          this.title = this.sanitizer.bypassSecurityTrustHtml(response.title);
          this.content = this.sanitizer.bypassSecurityTrustHtml(response.content);

      }



    });
  }

}
